(function () {
  const RITUAL_PRODUCT_IDS = [
    '15522520596804',
    '15522524004676',
    '15522524332356',
    '15641973784900'
  ];

  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input?.url || '');

    if (url.includes('/cart/add')) {
      const body = init?.body;
      if (body instanceof FormData) {
        const productId = body.get('product-id');
        if (productId && RITUAL_PRODUCT_IDS.includes(productId)) {
          body.set('properties[Ritual Sounds]', 'for free');
        }
        return originalFetch(input, { ...init, body });
      }
    }

    return originalFetch(input, init);
  };
})();
